import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
    /**
     * Constructor
     */
    constructor(private _authService: AuthService)
    {
    }


     getBrowserNameAndVersion() {
  const userAgent = navigator.userAgent;
  let browserName = "Unknown";
  let version = "";

  if (userAgent.includes("Edg/")) {
    browserName = "Edge";
    version = userAgent.match(/Edg\/([\d\.]+)/)?.[1];
  } else if (userAgent.includes("Chrome/")) {
    browserName = "Chrome";
    version = userAgent.match(/Chrome\/([\d\.]+)/)?.[1];
  } else if (userAgent.includes("Safari/") && !userAgent.includes("Chrome")) {
    browserName = "Safari";
    version = userAgent.match(/Version\/([\d\.]+)/)?.[1];
  } else if (userAgent.includes("Firefox/")) {
    browserName = "Firefox";
    version = userAgent.match(/Firefox\/([\d\.]+)/)?.[1];
  } else if (userAgent.includes("MSIE")) {
    browserName = "Internet Explorer";
    version = userAgent.match(/MSIE ([\d\.]+)/)?.[1];
  } else if (userAgent.includes("Trident/")) {
    browserName = "Internet Explorer";
    version = userAgent.match(/rv:([\d\.]+)/)?.[1];
  }

  return `${browserName} ${version}`;
}

 
    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        // Clone the request object
        let newReq = req.clone();

        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // the user out from the app.
        if ( this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken) )
        {
            newReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken).set('X-Forwarded-For', localStorage.getItem('ipAddress') || '').set('X-pageurl', window.location.pathname || '').set('X-Browser-Info', this.getBrowserNameAndVersion() || '').set('X-User-Location',  localStorage.getItem('userLocation') || '')
            });
        }

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {

                // Catch "401 Unauthorized" responses
                if ( error instanceof HttpErrorResponse && error.status === 401 )
                {
                    // Sign out
                    this._authService.signOut();

                    // Reload the app
                    location.reload();
                }

                return throwError(error);
            })
        );
    }
}
